// extractDocument uploads a document (PDF, DOCX, XLSX, HTML, Markdown, CSV, JSON, txt)
// to the server's in-process document-understanding pipeline (server/docparse,
// a "MarkItDown in Go") and returns the extracted retrieval text + metadata. The
// caller attaches the result to a character as knowledge (knowledge_docs), where
// it is chunked, indexed (gobed semantic when enabled), and retrieved at chat time.

export interface ExtractedDocument {
  name: string;
  contentType: string;
  text: string;
  preview: string;
  chars: number;
  words: number;
  truncated: boolean;
  title?: string;
}

// Extensions docparse can extract text from — used for the file picker's accept.
export const DOCUMENT_ACCEPT =
  '.pdf,.docx,.doc,.xlsx,.html,.htm,.md,.markdown,.txt,.csv,.json';

export async function extractDocument(file: File): Promise<ExtractedDocument> {
  const form = new FormData();
  form.append('file', file);
  const res = await fetch('/api/documents/extract', {
    method: 'POST',
    body: form,
    credentials: 'same-origin',
  });
  const body = await res.json().catch(() => null);
  if (!res.ok || !body?.success) {
    throw new Error(body?.error || `extract failed (${res.status})`);
  }
  return {
    name: body.name || file.name,
    contentType: body.content_type || '',
    text: body.text || '',
    preview: body.preview || '',
    chars: body.chars || 0,
    words: body.words || 0,
    truncated: Boolean(body.truncated),
    title: body.title || undefined,
  };
}
